if (!customElements.get('emergent-quickquote')) {
  customElements.define('emergent-quickquote', class extends HTMLElement {
    connectedCallback() {
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      Object.assign(this.copy, {ready:this.copy.recorder_ready, page_ready:this.copy.recorder_saved, page_unconfirmed:this.copy.recorder_unconfirmed, error:this.copy.recorder_error, page_missing:this.copy.recorder_missing, page_preparing:this.copy.recorder_preparing});
      this.form=this.querySelector('form'); this.panel=this.querySelector('[data-print-preview]');
      this.bodyField=this.querySelector('[data-contact-body]'); this.emailField=this.querySelector('[data-email]');
      this.dialog=this.querySelector('[data-email-dialog]'); this.continueButton=this.querySelector('[data-email-continue]'); this.cancelButton=this.querySelector('[data-email-cancel]');
      this.recordButton=this.querySelector('[data-record-quote]'); this.securityPanel=this.querySelector('[data-security-panel]');
      this.cartBase=new URL(this.dataset.cartUrl,location.href);
      this.liveMode=window.Shopify?.theme?.role==='main';
      const oldTicket=this.printTicketFromURL();
      if(oldTicket){
        const selected=new URL(location.href).searchParams.get('qq_env');
        if(selected==='test')this.liveMode=false;
        else if(selected==='live')this.liveMode=true;
        else if(sessionStorage.getItem('ecpap:recorded-test:v1:private:'+this.dataset.themeId+':'+oldTicket))this.liveMode=false;
      }
      this.recordPrefix=this.liveMode?'ecpap:recorded-live:v1:':'ecpap:recorded-test:v1:';
      this.storageKey=this.recordPrefix+this.dataset.themeId+':'+this.dataset.sectionId;
      this.sequence=0; this.snapshot=null; this.recordAccepted=null;
      const owner=this; this.status={get textContent(){return owner.statusMessage||'';},set textContent(value){owner.statusMessage=value;owner.refreshFooter();if(owner.securityPanel?.open)owner.querySelector('[data-security-status]').textContent=value;}};
      if(!this.allowed()) return;
      const ticket=this.printTicketFromURL();
      if(ticket){this.initializePrintPage(ticket);return;}
      this.onSubmit=e=>{e.preventDefault();e.stopImmediatePropagation();};
      this.form.addEventListener('submit',this.onSubmit,true);
      this.onPrintAsQuote=e=>{
        const open=e.target.closest?.('#main-cart-footer [data-qq-open-view]');
        const trigger=e.target.closest?.('[data-print-as-quote]');
        if(open&&this.lastRecordTicket){e.preventDefault();this.openPreparedQuote();}
        else if(trigger&&!trigger.disabled){e.preventDefault();e.stopImmediatePropagation();this.returnFocus=trigger;this.printAsQuote();}
      };
      this.onContinue=()=>{if(this.emailField.reportValidity()){this.dialog.close();if(this.refreshIntent)this.prepareRefresh();else this.createQuote();}};
      this.onCancel=e=>{e?.preventDefault();this.dialog.close();this.cancelRefresh();this.restorePreviousRecord();this.removeChallenge();this.returnFocus?.focus();};
      this.onRecord=()=>this.recordQuote();
      this.onInput=e=>{if(e.target===this.emailField&&this.dialog.open&&this.refreshIntent)return;if(e.target.matches?.('[name="attributes[PO]"], [name="attributes[Note]"], [data-assertion], cart-items input[name="updates[]"]'))this.invalidate('stale');};
      document.addEventListener('click',this.onPrintAsQuote,true);
      document.addEventListener('input',this.onInput);document.addEventListener('change',this.onInput);
      this.continueButton?.addEventListener('click',this.onContinue);this.cancelButton?.addEventListener('click',this.onCancel);this.dialog?.addEventListener('cancel',this.onCancel);
      this.recordButton.addEventListener('click',this.onRecord);
      this.onNewRecord=()=>this.startRefresh();
      this.querySelector('[data-new-test]').addEventListener('click',this.onNewRecord);
      this.onRecordReopen=()=>this.openPreparedQuote();this.querySelector('[data-record-reopen]').addEventListener('click',this.onRecordReopen);
      this.onSecurityCancel=e=>{e?.preventDefault();if(!this.recording){if(this.feedbackMode){this.invalidate('stale');this.securityPanel.close();this.securityPanel.hidden=true;this.returnFocus?.focus();return;}this.invalidate('stale');this.restorePreviousRecord();this.status.textContent='';this.returnFocus?.focus();}};
      this.querySelector('[data-security-cancel]').addEventListener('click',this.onSecurityCancel);
      this.securityPanel.addEventListener('cancel',this.onSecurityCancel);
      this.onPageHide=()=>{this.invalidate('stale');this.restorePreviousRecord();};window.addEventListener('pagehide',this.onPageHide);
      this.footerObserver=new MutationObserver(()=>this.refreshFooter());this.footerObserver.observe(document.body,{childList:true,subtree:true});
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.invalidate('stale'));
      try{const last=JSON.parse(sessionStorage.getItem(this.storageKey+':last'));if(last?.ticket){this.readLocalRecord(last.ticket);this.lastRecordTicket=last.ticket;this.status.textContent=this.copy.page_unconfirmed;}}catch{}
      this.updateButtons();
    }

    disconnectedCallback() {
      this.sequence++;this.abort?.abort();this.unsubscribe?.();clearTimeout(this.expiryTimer);clearTimeout(this.operationTimer);clearInterval(this.tabWatch);
      this.cancelRefresh();this.removeChallenge();this.footerObserver?.disconnect();
      document.removeEventListener('click',this.onPrintAsQuote,true);document.removeEventListener('input',this.onInput);document.removeEventListener('change',this.onInput);
      window.removeEventListener('beforeprint',this.onBeforePrint);window.removeEventListener('pagehide',this.onPageHide);window.removeEventListener('pageshow',this.onPageShow);
      this.printNowButton?.removeEventListener('click',this.onPrintNow);this.continueButton?.removeEventListener('click',this.onContinue);this.cancelButton?.removeEventListener('click',this.onCancel);this.dialog?.removeEventListener('cancel',this.onCancel);this.recordButton?.removeEventListener('click',this.onRecord);
      this.form?.removeEventListener('submit',this.onSubmit,true);this.cleanupPrint();
      this.querySelector('[data-new-test]')?.removeEventListener('click',this.onNewRecord);
      this.querySelector('[data-record-reopen]')?.removeEventListener('click',this.onRecordReopen);
      this.querySelector('[data-security-cancel]')?.removeEventListener('click',this.onSecurityCancel);
      this.securityPanel?.removeEventListener('cancel',this.onSecurityCancel);
      this.securityPanel?.close();
    }

    ensureDiagnosticMarker(container) {
      if (!container || !this.allowed()) return;
      container.setAttribute('data-qq-diagnostic-build', 'QQREQUEST1-20261024');
      container.querySelectorAll('p[data-qq-diagnostic-build]').forEach(marker => marker.remove());
    }

    failureText(reason, diagnostic = '') {
      const fallback = reason === 'comparison_error' ? 'QQ-V00' : (reason === 'stale' ? 'QQ-U01' : '');
      const code = /^QQ-[A-Z][0-9]{2}$/.test(diagnostic) ? diagnostic : fallback;
      const detail = reason === 'comparison_error' && code === 'QQ-V04' ? (this.itemMismatchDetail || '') : '';
      return this.copy[reason] || this.copy.error;
    }

    decorateFailureMessage(message) {
      if (message === this.copy.comparison_error) return this.failureText('comparison_error');
      if (message === this.copy.stale) return this.failureText('stale', this.staleDiagnostic);
      return message;
    }

    refreshFooter() {
      const enabled=this.allowed();
      for(const n of document.querySelectorAll('[data-qq-enabled-control]:not(.qq-quote-actions__support)'))if(n.hidden===enabled)n.hidden=!enabled;
      const ctas=document.querySelector('#main-cart-footer .cart__ctas');
      if(ctas&&ctas.classList.contains('qq-quote-actions')!==enabled)ctas.classList.toggle('qq-quote-actions',enabled);
      const buttons=document.querySelectorAll('#main-cart-footer [data-print-as-quote]');this.button=buttons.length===1?buttons[0]:null;
      for(const b of document.querySelectorAll('[data-print-as-quote]')){b.disabled=!enabled||!this.button||Boolean(this.busy||this.recording||this.openingRecord||this.refreshIntent);const label=this.copy.print_as_quote;if(b.textContent!==label)b.textContent=label;}
      for(const n of document.querySelectorAll('#main-cart-footer .qq-quote-actions__support, #main-cart-footer [data-qq-open-view], #main-cart-footer [data-qq-footer-status], #main-cart-footer .qq-quote-actions__help, #main-cart-footer .qq-quote-actions__captcha')){if(!n.hidden)n.hidden=true;}
      const reopen=this.querySelector('[data-record-reopen]');if(reopen)reopen.disabled=Boolean(this.openingRecord||this.recording||this.refreshIntent);
      const fresh=this.querySelector('[data-new-test]');if(fresh){
        fresh.disabled=Boolean(this.busy||this.openingRecord||this.recording||this.refreshIntent||!this.previousVerified);
        const checkout=document.querySelector('#main-cart-footer #checkout');
        if(checkout){const style=getComputedStyle(checkout);for(const key of ['--color-button','--color-button-text','--alpha-button-background']){const value=style.getPropertyValue(key);if(value&&fresh.style.getPropertyValue(key)!==value)fresh.style.setProperty(key,value);}}
      }
      const close=this.querySelector('[data-security-cancel]');if(close)close.disabled=Boolean(this.recording);
      if(this.recordButton)this.recordButton.disabled=!this.turnstileToken||Boolean(this.busy||this.recording)||!this.snapshot||!enabled;
    }

    returnToCartURL() {
      const url = new URL(this.cartBase);
      if (window.Shopify?.theme?.role !== 'main') url.searchParams.set('preview_theme_id', this.dataset.themeId);
      return url.href;
    }

    numericReference(reference) {
      const parts = /^QQ-([1-9][0-9]*)-([a-f0-9]{12})$/.exec(reference);
      if (!parts) throw new Error('snapshot_error');
      return parts[1] + (BigInt('0x' + parts[2]) % 1000000n).toString().padStart(6, '0');
    }

    displayReference(server = this.snapshot.server) {
      return server.quoteNumber;
    }

    expirationISO(server) {
      return new Date((server.renderedAt + 30 * 86400) * 1000).toISOString();
    }

    quoteDate(epoch) {
      return new Date(epoch * 1000).toLocaleDateString(document.documentElement.lang || 'en', {year:'numeric', month:'short', day:'numeric', timeZone:'UTC'});
    }

    printTicketFromURL() {
      const value = new URL(location.href).searchParams.get('qq_print');
      return /^[a-f0-9-]{36}$/.test(value || '') ? value : null;
    }

    recordKey(ticket) {
      if(!/^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/.test(ticket||''))throw new Error('page_missing');
      return this.recordPrefix+'private:'+this.dataset.themeId+':'+ticket;
    }

    printURL(ticket) {
      this.recordKey(ticket);const url=new URL(this.returnToCartURL());url.searchParams.set('qq_print',ticket);url.searchParams.set('qq_env',this.liveMode?'live':'test');url.hash='';return url;
    }


    needsLegacyCheck() {
      if(!this.liveMode||this.isPrintPage||this.legacySettled)return false;
      try {
        const raw=sessionStorage.getItem('ecpap:recorded-test:v1:'+this.dataset.themeId+':'+this.dataset.sectionId+':last');
        if(!raw){this.legacySettled=true;return false;}
      }catch{}
      return true;
    }

    async ensureLegacySettled() {
      if(!this.liveMode||this.isPrintPage||this.legacySettled)return true;
      if(this.legacyCheck)return this.legacyCheck;
      const sequence=this.sequence;
      this.legacyCheck=(async()=>{
        try{
          const prefix='ecpap:recorded-test:v1:';
          const last=JSON.parse(sessionStorage.getItem(prefix+this.dataset.themeId+':'+this.dataset.sectionId+':last')||'null');
          if(!last?.ticket){this.legacySettled=true;return true;}
          this.recordKey(last.ticket);
          const record=JSON.parse(sessionStorage.getItem(prefix+'private:'+this.dataset.themeId+':'+last.ticket)||'null');
          if(record?.schema!=='ECPAP-TEST-RECOVERY-1'||record.ticket!==last.ticket||record.requestId!==last.ticket||!/^[a-f0-9]{64}$/.test(record.recoverySecret||'')||!record.snapshot)throw new Error('page_unconfirmed');
          const receipt=await this.backend('/recover',{requestId:record.requestId,recoverySecret:record.recoverySecret},false);
          await this.verifyReceipt(receipt,record,false);
          if(sequence!==this.sequence||!this.isConnected)return false;
          this.legacySettled=true;return true;
        }catch{if(sequence===this.sequence&&this.isConnected)this.showFeedback(this.copy.page_unconfirmed);return false;}
      })();
      try{return await this.legacyCheck;}finally{this.legacyCheck=null;}
    }

    async createQuote() {
      if(this.legacyCheck)return false;
      if(this.needsLegacyCheck()&&!await this.ensureLegacySettled())return false;
      if(this.busy||this.recording||this.lastRecordTicket||!this.allowed()||!this.emailField.reportValidity())return false;
      if(!await this.generate()){this.restorePreviousRecord();this.showFeedback(this.status.textContent);return false;}
      this.feedbackMode=false;this.recordButton.hidden=false;this.querySelector('[data-turnstile]').hidden=false;this.querySelector('[data-record-help]').hidden=false;this.querySelector('[data-record-reopen]').hidden=true;this.querySelector('[data-new-test]').hidden=true;
      this.requestId=crypto.randomUUID();this.securityPanel.hidden=false;this.securityPanel.showModal();
      this.querySelector('[data-security-status]').textContent=this.copy.recorder_security;
      try{await this.showChallenge(this.requestId);return true;}catch{this.querySelector('[data-security-status]').textContent='Security check could not load. Cancel and try again. No request was submitted.';return false;}
    }

    async printAsQuote() {
      if(this.legacyCheck)return false;
      if(this.needsLegacyCheck()&&!await this.ensureLegacySettled())return false;
      if(this.busy||this.recording||this.openingRecord||!this.allowed())return false;
      if(this.securityPanel.open){(this.feedbackMode?this.querySelector(this.previousVerified?'[data-new-test]':'[data-record-reopen]'):this.recordButton).focus();return false;}
      if(this.lastRecordTicket)return this.reviewSavedQuote();
      if(this.dataset.signedIn!=='true'){this.dialog.showModal();this.emailField.focus();return false;}
      return this.createQuote();
    }

    restorePreviousRecord() {
      if(!this.previousRecordTicket)return;
      this.lastRecordTicket=this.previousRecordTicket;this.previousRecordTicket=null;this.previousVerified=false;
      sessionStorage.setItem(this.storageKey+':last',JSON.stringify({ticket:this.lastRecordTicket}));
    }

    async reviewSavedQuote() {
      // Read current server cart data, never the initial page envelope. A previous
      // receipt remains immutable and an uncertain submission must recover first.
      this.previousVerified=false;this.currentCartChanged=false;
      let message=this.copy.page_unconfirmed;
      const completed=await this.run(async()=>{
        const sequence=this.sequence,ticket=this.lastRecordTicket;
        const record=this.readLocalRecord(ticket);
        const receipt=await this.backend('/recover',{requestId:record.requestId,recoverySecret:record.recoverySecret});
        await this.verifyReceipt(receipt,record);
        if(sequence!==this.sequence||!this.isConnected||ticket!==this.lastRecordTicket)throw new Error('stale');
        if(this.cartPending()||window.EmergentNativeFields?.checkoutPending)throw new Error('wait_cart');
        const fields=this.fields(),assertions=this.assertions();
        message='Your previous quote is saved. The current cart could not be checked yet. Wait for cart updates to finish, then close this dialog and try again.';
        const current=await this.serverEnvelope();
        const cart=await this.readCart();this.compare(current,cart);
        const final=await this.serverEnvelope();
        if(this.stableMap(current)!==this.stableMap(final)||sequence!==this.sequence||this.cartPending()||!this.isConnected||JSON.stringify(fields)!==JSON.stringify(this.fields())||JSON.stringify(assertions)!==JSON.stringify(this.assertions()))throw new Error('stale');
        const previous=await this.parseEnvelope(receipt.snapshot.envelope);
        if(sequence!==this.sequence||!this.isConnected||ticket!==this.lastRecordTicket||this.cartPending())throw new Error('stale');
        const content=server=>JSON.stringify(Object.entries(server.map).filter(([key])=>!['rendered_at_epoch','rendered_at_iso','generation_nonce','po_assertion','note_assertion'].includes(key)).sort(([a],[b])=>a.localeCompare(b)));
        this.currentCartChanged=content(previous)!==content(current)||JSON.stringify(fields)!==JSON.stringify(record.snapshot.fields)||(assertions.email&&assertions.email!==record.snapshot.email);
        this.previousVerified=true;
        message=this.currentCartChanged?'Your cart or quote details have changed. Refresh quote creates a new quote for your current cart. You can also reopen your previous quote.':'Your current cart matches your saved quote. Refresh quote creates a new quote, or you can reopen the saved quote without sending another request.';
      });
      if(this.isConnected)this.showFeedback(message);
      return completed;
    }

    async openPreparedQuote() {
      if(this.openingRecord||this.busy||this.recording||this.refreshIntent)return false;this.openingRecord=true;this.previousVerified=false;this.updateButtons();
      let child;
      try{const record=this.readLocalRecord(this.lastRecordTicket);child=this.openRecordTab(record);child.location.replace(this.printURL(record.ticket).href);
        const receipt=await this.backend('/recover',{requestId:record.requestId,recoverySecret:record.recoverySecret});await this.verifyReceipt(receipt,record);
        this.previousVerified=true;this.querySelector('[data-new-test]').hidden=false;this.status.textContent=this.notificationMessage(receipt);return true;}
      catch{this.status.textContent=child?this.copy.page_unconfirmed:'Allow pop-ups to check this existing request. No new request will be submitted.';return false;}
      finally{this.openingRecord=false;this.updateButtons();this.showFeedback(this.status.textContent);}
    }

    showFeedback(message) {
      this.feedbackMode=true;this.removeChallenge();this.recordButton.hidden=true;
      this.querySelector('[data-turnstile]').hidden=true;this.querySelector('[data-record-help]').hidden=true;
      this.querySelector('[data-record-reopen]').hidden=!this.lastRecordTicket;
      this.querySelector('[data-new-test]').hidden=!this.previousVerified;
      this.querySelector('[data-new-test]').textContent=this.copy.recorder_another;
      this.securityPanel.hidden=false;if(!this.securityPanel.open)this.securityPanel.showModal();
      this.status.textContent=message;this.updateButtons();
      if(this.previousVerified&&this.lastRecordTicket){this.requestId=crypto.randomUUID();this.querySelector('[data-turnstile]').hidden=false;this.querySelector('[data-record-help]').hidden=false;this.showChallenge(this.requestId).catch(()=>{if(this.securityPanel.open)this.status.textContent='Security check could not load. Close this dialog and try again. No request was submitted.';});}
      const primary=this.querySelector(this.previousVerified?'[data-new-test]':this.lastRecordTicket?'[data-record-reopen]':'[data-security-cancel]');if(!primary.disabled)primary.focus();
    }

    cancelRefresh() {
      const intent=this.refreshIntent;this.refreshIntent=null;
      clearInterval(this.refreshWatch);
      if(intent?.child&&!this.recording)intent.child.close();
    }

    async startRefresh() {
      if(!this.previousVerified||!this.lastRecordTicket||this.refreshIntent||this.busy||this.recording||this.openingRecord)return false;
      let child;
      try {
        child=window.open('about:blank','qq_record_'+this.requestId.replaceAll('-',''));
        if(!child||child.closed)throw new Error('print_tab_unavailable');
        child.document.title=this.copy.recorder_waiting;child.document.body.textContent=this.copy.recorder_waiting_tab;child.opener=null;
      } catch {child?.close();this.status.textContent=this.copy.recorder_popup;return false;}
      this.refreshIntent={requestId:this.requestId,child,ready:false};
      this.refreshWatch=setInterval(()=>{if(this.refreshIntent?.child.closed){this.invalidate('stale');this.restorePreviousRecord();}},300);
      this.previousRecordTicket=this.lastRecordTicket;this.lastRecordTicket=null;this.previousVerified=false;
      this.updateButtons();
      if(!this.emailField.checkValidity()){this.refreshIntent.awaitingEmail=true;this.securityPanel.close();this.dialog.showModal();this.emailField.focus();return false;}
      return this.prepareRefresh();
    }

    async prepareRefresh() {
      const intent=this.refreshIntent;
      if(!intent||this.busy||this.recording)return false;
      this.securityPanel.hidden=false;if(!this.securityPanel.open)this.securityPanel.showModal();
      if(intent.awaitingEmail&&!this.turnstileToken){try{await this.showChallenge(intent.requestId);}catch{this.cancelRefresh();this.restorePreviousRecord();this.showFeedback('Security check could not load. Close this dialog and try again.');return false;}}
      intent.awaitingEmail=false;
      const generated=await this.generate(true);
      if(this.refreshIntent!==intent)return false;
      if(!generated){this.cancelRefresh();this.restorePreviousRecord();this.showFeedback(this.status.textContent);return false;}
      intent.ready=true;this.status.textContent='Preparing your refreshed quote. If a CAPTCHA appears, please complete it.';
      return this.finishRefresh();
    }

    async finishRefresh() {
      const intent=this.refreshIntent;
      if(!intent?.ready||this.busy||this.recording||intent.requestId!==this.requestId||!this.securityPanel.open)return false;
      if(intent.child.closed){this.invalidate('stale');this.restorePreviousRecord();return false;}
      if(!this.turnstileToken)return false;
      if(Date.now()-this.tokenReceivedAt>=290000){this.removeChallenge();await this.showChallenge(this.requestId);return false;}
      if(!this.isReady()){this.invalidate('stale');this.restorePreviousRecord();this.showFeedback(this.status.textContent);return false;}
      this.refreshIntent=null;clearInterval(this.refreshWatch);
      return this.recordQuote(intent.child);
    }

    brandNode() {
      const brand = this.node('p', null, 'qq-doc__brand'), fallback = this.node('span', this.copy.brand);
      const original = this.querySelector('[data-qq-brand-logo]')?.content.querySelector('img');
      if (original) {
        const logo = original.cloneNode(true);
        logo.alt = this.copy.brand;
        logo.hidden = true;logo.loading = 'eager';
        const show = () => { logo.hidden = false; fallback.hidden = true; if(this.printReady)this.layoutPrintPages(); };
        logo.addEventListener('load', show, {once:true});
        logo.addEventListener('error', () => { logo.hidden = true; fallback.hidden = false; }, {once:true});
        brand.append(logo);
        if (logo.complete && logo.naturalWidth > 0) show();
      }
      brand.append(fallback);
      return brand;
    }

    initializePrintPage(ticket) {
      this.isPrintPage = true;
      this.printTicket = ticket;
      document.documentElement.classList.add('qq-print-page');
      this.printToolbar = this.querySelector('[data-qq-print-toolbar]');
      this.printToolbar.hidden = false;
      this.ensureDiagnosticMarker(this.printToolbar);
      this.printNowButton = this.querySelector('[data-qq-print-now]');
      this.printNowButton.disabled = true;
      this.printMessage = this.querySelector('[data-qq-print-status]');
      this.querySelector('[data-qq-back]').href = this.returnToCartURL();
      this.onPrintNow = () => {
        this.printSequence = (this.printSequence || 0) + 1;
        this.printFixedNow();
      };
      this.printNowButton.addEventListener('click', this.onPrintNow);
      this.onBeforePrint = () => document.documentElement.classList.toggle('qq-demo-print-authorized', this.canPrintFixed());
      window.addEventListener('beforeprint', this.onBeforePrint);
      this.onPageShow = event => { if (event.persisted) this.resumePromise = this.loadPrintRecord(ticket); };
      this.tabWatch = setInterval(() => { if (this.printReady) this.canPrintFixed(); }, 500);
      this.onPageHide = () => { this.printLoadSequence = (this.printLoadSequence || 0) + 1; this.abort?.abort(); this.printReady = false; this.panel.hidden = true; this.cleanupPrint(); };
      window.addEventListener('pageshow', this.onPageShow);
      window.addEventListener('pagehide', this.onPageHide);
      this.resumePromise = this.loadPrintRecord(ticket);
    }

    canPrintFixed() {
      return Boolean(this.printReady&&this.snapshot?.receipt&&this.recordAccepted===this.snapshot.contactBody&&this.allowed());
    }

    async loadPrintRecord(ticket) {
      const sequence=this.printLoadSequence=(this.printLoadSequence||0)+1;
      this.printReady=false;this.recordAccepted=null;this.snapshot=null;this.panel.hidden=true;this.panel.replaceChildren();this.printNowButton.disabled=true;
      try{
        const record=this.readLocalRecord(ticket);
        const receipt=await this.backend('/recover',{requestId:record.requestId,recoverySecret:record.recoverySecret});
        await this.verifyReceipt(receipt,record);
        const parsed=await this.parseEnvelope(receipt.snapshot.envelope);
        if(parsed.map.po_assertion!==receipt.snapshot.fields.PO||parsed.map.note_assertion!==receipt.snapshot.fields.Note)throw new Error('snapshot_error');
        const server={...parsed,quoteNumber:receipt.reference,renderedAt:Date.parse(receipt.recordedAt)/1000};this.validatePrintTotals(server);
        if(sequence!==this.printLoadSequence)return false;
        const body=JSON.stringify(receipt);this.snapshot={server,fields:receipt.snapshot.fields,assertions:{email:receipt.snapshot.email,name:''},contactBody:body,receipt};this.recordAccepted=body;
        this.render(this.snapshot);this.panel.hidden=false;
        document.title='Quick Quote '+receipt.reference;
        this.printMessage.textContent=this.notificationMessage(receipt);
        await this.waitForPrintAssets();
        if(sequence!==this.printLoadSequence)return false;
        this.layoutPrintPages();this.printReady=true;this.printNowButton.disabled=false;return true;
      }catch{this.printMessage.textContent=this.copy.page_unconfirmed+' Reload this tab to check again. This action never resubmits.';return false;}
    }

    printFixedNow() {
      if (!this.isPrintPage || !this.canPrintFixed() || this.printInvoking) return false;
      this.printInvoking = true;
      try {
        this.layoutPrintPages();
        document.documentElement.classList.add('qq-demo-print-authorized');
        window.print();
        return true;
      } catch (error) {
        this.printMessage.textContent = this.failureText(error.message, error.quoteDiagnostic);
        return false;
      } finally { this.printInvoking = false; }
    }

    async waitForPrintAssets() {
      const images = [...this.panel.querySelectorAll('.qq-doc__flow img')].map(image => {
        image.loading = 'eager';
        if (image.complete) return image.decode?.().catch(() => undefined) || Promise.resolve();
        return new Promise(resolve => { image.addEventListener('load', resolve, {once:true}); image.addEventListener('error', resolve, {once:true}); });
      });
      await Promise.race([Promise.all([document.fonts?.ready || Promise.resolve(), ...images]), new Promise(resolve => setTimeout(resolve, 5000))]);
    }

    async printSnapshot() {
      if (!this.isPrintPage || !this.canPrintFixed() || this.printPreparing) return false;
      this.printPreparing = true;
      const sequence = this.printSequence || 0;
      try {
        const images = [...this.panel.querySelectorAll('img')].map(image => {
          image.loading = 'eager';
          if (image.complete) return image.decode?.().catch(() => undefined) || Promise.resolve();
          return new Promise(resolve => { image.addEventListener('load', resolve, {once:true}); image.addEventListener('error', resolve, {once:true}); });
        });
        await Promise.race([Promise.all([document.fonts?.ready || Promise.resolve(), ...images]), new Promise(resolve => setTimeout(resolve, 5000))]);
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        await new Promise(resolve => setTimeout(resolve, 750));
        if (sequence !== (this.printSequence || 0)) return false;
        if (!this.canPrintFixed()) throw new Error('page_expired');
        return this.printFixedNow();
      } catch (error) {
        this.printMessage.textContent = this.failureText(error.message, error.quoteDiagnostic);
        return false;
      } finally { this.printPreparing = false; }
    }


    allowed() {
      return this.dataset.enabled==='true'&&this.dataset.themeId==='159941787853'&&String(window.Shopify?.theme?.id)===this.dataset.themeId&&['unpublished','main'].includes(window.Shopify?.theme?.role)&&this.dataset.recorder==='https://emergent-quickquote-test.help-fb5.workers.dev'&&this.dataset.sitekey==='0x4AAAAAAFkrmaNOCVAHzKNA'&&!new URL(location.href).searchParams.has('view')&&this.cartBase.origin===location.origin&&/\/cart$/.test(this.cartBase.pathname)&&location.pathname===this.cartBase.pathname&&!this.cartBase.search&&!this.cartBase.hash;
    }

    text(value, max = 4000) {
      if (typeof value !== 'string' || value.length > max) throw new Error('snapshot_error');
      return value;
    }

    integer(value, minimum = 0) {
      if (!/^(0|[1-9]\d*)$/.test(String(value)) || !Number.isSafeInteger(Number(value)) || Number(value) < minimum) throw new Error('snapshot_error');
      return Number(value);
    }

    assertions() {
      return Object.fromEntries([...this.querySelectorAll('[data-assertion]')].map(node => [node.dataset.assertion, this.text(node.value, 250)]));
    }

    fields() {
      const result = {};
      for (const key of ['PO', 'Note']) {
        const nodes = [...document.querySelectorAll(`[name="attributes[${key}]"]`)].filter(node => node.form?.id === 'cart' || node.getAttribute('form') === 'cart');
        if (nodes.length !== 1 || nodes.some(node => node.value !== nodes[0].value || !node.checkValidity())) throw new Error('missing_fields');
        result[key] = this.text(nodes[0].value);
      }
      return result;
    }

    cartPending() {
      return Boolean(document.querySelector('cart-items .cart__items--disabled')) || [...document.querySelectorAll('cart-items input[name="updates[]"]')].some(node => node.value !== node.defaultValue);
    }

    invalidate(reason='stale',diagnostic='',preserveChallenge=false) {
      this.sequence++;this.abort?.abort();clearTimeout(this.expiryTimer);this.snapshot=null;this.bodyField.value='';if(!preserveChallenge){this.cancelRefresh();this.restorePreviousRecord();this.removeChallenge();}if(this.securityPanel&&!preserveChallenge){this.securityPanel.close();this.securityPanel.hidden=true;}
      this.panel.hidden=true;this.cleanupPrint();
      // A changed cart never changes or deletes a submitted immutable record.
      this.status.textContent=this.lastRecordTicket?this.copy.recorder_changed:this.failureText(reason,diagnostic);
      this.updateButtons();
    }

    updateButtons() {
      this.refreshFooter();if(this.continueButton)this.continueButton.disabled=Boolean(this.busy||this.recording||!this.allowed());
    }

    isReady() {
      if (!this.snapshot || !this.allowed() || this.cartPending()) return false;
      const age = Date.now() / 1000 - this.snapshot.server.renderedAt;
      if (age < -60 || age > 300 || performance.now() - this.snapshot.createdPerformance > 300000) return false;
      try { return JSON.stringify(this.fields()) === JSON.stringify(this.snapshot.fields) && JSON.stringify(this.assertions()) === JSON.stringify(this.snapshot.assertions) && this.bodyField.value === this.snapshot.contactBody; }
      catch { return false; }
    }

    failureError(reason, diagnostic) {
      const error = new Error(reason);
      error.quoteDiagnostic = diagnostic;
      return error;
    }

    staleError(diagnostic) {
      return this.failureError('stale', diagnostic);
    }

    readinessDiagnostic() {
      // Called only after the unchanged readiness gate has already failed.
      // Return a fixed code; never expose field values, cart data or tokens.
      if (!this.snapshot) return 'QQ-R01';
      if (!this.allowed()) return 'QQ-R02';
      if (this.cartPending()) return 'QQ-R03';
      const age = Date.now() / 1000 - this.snapshot.server.renderedAt;
      if (age < -60 || age > 300) return 'QQ-R04';
      if (performance.now() - this.snapshot.createdPerformance > 300000) return 'QQ-R05';
      try {
        if (JSON.stringify(this.fields()) !== JSON.stringify(this.snapshot.fields)) return 'QQ-R06';
        if (JSON.stringify(this.assertions()) !== JSON.stringify(this.snapshot.assertions)) return 'QQ-R07';
        if (this.bodyField.value !== this.snapshot.contactBody) return 'QQ-R08';
      } catch { return 'QQ-R09'; }
      return 'QQ-R00';
    }

    async request(url, options = {}) {
      if (url.origin !== location.origin) throw new Error('snapshot_error');
      const response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: this.abort.signal, ...options});
      if (!response.ok) throw new Error('error');
      return response;
    }

    async readCart() {
      const url = new URL(this.cartBase.href + '.js');
      url.searchParams.set('_qq_request', crypto.randomUUID());
      const cart = await (await this.request(url, {headers: {Accept: 'application/json'}})).json();
      if (Array.isArray(cart?.items) && cart.items.some(item => item.has_components === true && !Object.hasOwn(item, 'item_components'))) {
        // Native bundle AJAX lines can declare components without serializing them.
        // Keep an separate Liquid cart observation bound to this exact response.
        const witness = await this.serverEnvelope();
        this.bundleWitnesses ||= new WeakMap();
        this.bundleWitnesses.set(cart, witness);
      }
      return cart;
    }

    checkReadback(cart, fields, nonce) {
      if (!cart || (cart.attributes?.PO ?? '') !== fields.PO || (cart.attributes?.Note ?? '') !== fields.Note || cart.attributes?.['QuickQuote request nonce'] !== nonce) throw new Error('readback_error');
    }

    async serverEnvelope() {
      const url = new URL(this.cartBase);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.set('_qq_request', crypto.randomUUID());
      const response = await this.request(url, {headers: {Accept: 'text/html'}});
      const html = await response.text();
      if (html.length > 500000) throw new Error('capacity_error');
      const document = new DOMParser().parseFromString(html, 'text/html');
      const candidates = document.querySelectorAll('emergent-quickquote[data-theme-id="' + this.dataset.themeId + '"] [data-qq-server-envelope]');
      if (candidates.length !== 1) throw new Error('snapshot_error');
      return this.parseEnvelope(JSON.parse(candidates[0].textContent));
    }

    async parseEnvelope(envelope) {
      if (envelope?.schema !== 'ECPAP-QQ-REQUEST-1') throw new Error('terms_refresh_error');
      if (envelope?.schema !== 'ECPAP-QQ-REQUEST-1' || envelope.issuer_authenticated !== false || !/^[a-f0-9]{64}$/.test(envelope.checksum_sha256) || !/^[A-Za-z0-9+/=]+$/.test(envelope.payload_b64) || envelope.payload_b64.length > 90000) throw new Error('snapshot_error');
      const bytes = Uint8Array.from(atob(envelope.payload_b64), character => character.charCodeAt(0));
      const canonical = new TextDecoder('utf-8', {fatal: true}).decode(bytes);
      if (!canonical.endsWith('\n') || canonical.includes('\r') || /[^\x00-\x7f]/.test(canonical)) throw new Error('snapshot_error');
      // Unkeyed checksum detects accidental corruption; it does not authenticate a sender or price.
      const checksum = [...new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))].map(byte => byte.toString(16).padStart(2, '0')).join('');
      if (checksum !== envelope.checksum_sha256) throw new Error('snapshot_error');
      const map = Object.create(null);
      for (const line of canonical.slice(0, -1).split('\n')) {
        const at = line.indexOf('=');
        const name = line.slice(0, at), value = line.slice(at + 1);
        if (at < 1 || !/^[a-z0-9_.]+$/.test(name) || Object.hasOwn(map, name) || /%(?![0-9a-f]{2})/i.test(value)) throw new Error('snapshot_error');
        map[name] = decodeURIComponent(value.replace(/\+/g, ' '));
      }
      if (map.schema !== envelope.schema || map.mode !== 'QUOTE_REQUEST_SUBJECT_TO_VERIFICATION' || map.checksum_algorithm !== 'SHA-256-UNKEYED' || map.netwise_status !== 'NOT_INDEPENDENTLY_VERIFIED' || map.shipping_status !== 'NOT_CALCULATED' || !(map.terms_version === 'QQ-TERMS-2026-10-24-v1') || !/^[A-Z]{3}$/.test(map.currency)) throw new Error('snapshot_error');
      const documentCopy = JSON.parse(map.document_copy);
      const orderTerms = map.terms_version === 'QQ-TERMS-2026-10-24-v1';
      const conciseTerms = orderTerms;
      const documentKeys = ["snapshot_heading", ...(!conciseTerms ? ["quick_quote_note"] : []), "legal_name", "legal_entity", "trade_name", "dba", "business_ein", "business_address", "business_email", "business_phone", "terms_url", "terms_link_label", "sale_terms", "payment_terms", "credit_terms", "validity_terms", "pricing_error_terms", "shipping_tax", "custom_quote_heading", "custom_quote_text", "rfq_url", "discounts_heading", "discounts_included", "cart_discount_scope", "unnamed_discount", "terms_heading", "return_to_cart", "brand"];
      if ((map.terms_version === 'QQ-TERMS-2026-10-24-v1')) documentKeys.push('expiration_date', 'po_instruction', 'form_revision', ...(!conciseTerms ? ['receipt_confirmed', 'receipt_unconfirmed'] : []));
      if (orderTerms) documentKeys.push('order_terms_heading', 'order_terms');
      if (!documentCopy || Array.isArray(documentCopy) || Object.keys(documentCopy).length !== documentKeys.length || documentKeys.some(key => !Object.hasOwn(documentCopy, key) || typeof documentCopy[key] !== 'string' || !documentCopy[key].trim() || documentCopy[key].length > 2000)) throw new Error('snapshot_error');
      if (documentCopy.terms_url !== 'https://emergentcpap.com/pages/terms-and-conditions' || documentCopy.rfq_url !== 'https://emergentcpap.com/pages/rfq' || documentCopy.business_email !== 'help@emergentcpap.com' || documentCopy.terms_link_label !== 'Terms and Conditions') throw new Error('snapshot_error');
      if (map.terms_text !== ["shipping_tax", "payment_terms", "credit_terms", "validity_terms", "sale_terms", "terms_url", "pricing_error_terms", ...(!conciseTerms ? ["quick_quote_note"] : []), "custom_quote_text", "rfq_url", "business_email", ...((map.terms_version === 'QQ-TERMS-2026-10-24-v1') ? ["po_instruction", "form_revision"] : []), ...(orderTerms ? ["order_terms_heading", "order_terms"] : [])].map(key => documentCopy[key]).join('\n')) throw new Error('snapshot_error');
      Object.freeze(documentCopy); Object.freeze(map);
      const readApp = prefix => Object.fromEntries(['title', 'type', 'value', 'value_type', 'target_type', 'target_selection', 'total_allocated_amount'].map(field => [field, map[prefix + field] ?? '']));
      const count = key => { const number = this.integer(map[key]); if (number > 50) throw new Error('capacity_error'); return number; };
      const items = Array.from({length: count('line_count')}, (_, index) => {
        const prefix = `line.${index}.`;
        const item = Object.fromEntries(['key', 'product_id', 'variant_id', 'sku', 'title'].map(field => [field, this.text(map[prefix + field])]));
        for (const field of ['quantity', 'original_price', 'final_price', 'original_line_price', 'final_line_price', 'line_level_total_discount']) item[field] = this.integer(map[prefix + field], field === 'quantity' ? 1 : 0);
        item.allocations = Array.from({length: count(prefix + 'allocation_count')}, (_, number) => ({amount: this.integer(map[prefix + `allocation.${number}.amount`]), application: readApp(prefix + `allocation.${number}.`)}));
        item.components = Array.from({length: count(prefix + 'component_count')}, (_, number) => ({variant_id: this.text(map[prefix + `component.${number}.variant_id`]), sku: this.text(map[prefix + `component.${number}.sku`]), quantity: this.integer(map[prefix + `component.${number}.quantity`], 1)}));
        return item;
      });
      if (!items.length) throw new Error('capacity_error');
      const totals = Object.fromEntries(['original_total_price', 'items_subtotal_price', 'total_discount', 'total_price'].map(field => [field, this.integer(map[field])]));
      const allDiscounts = Array.from({length: count('all_discount_count')}, (_, index) => readApp(`all_discount.${index}.`));
      const cartDiscounts = Array.from({length: count('cart_discount_count')}, (_, index) => readApp(`cart_discount.${index}.`));
      if (totals.total_discount > 0 && !allDiscounts.length && !cartDiscounts.length && !items.some(item => item.allocations.length)) throw new Error('capacity_error');
      const renderedAt = this.integer(map.rendered_at_epoch, 1);
      if (envelope.quote_reference !== `QQ-${renderedAt}-${envelope.checksum_sha256.slice(0, 12)}`) throw new Error('snapshot_error');
      const recipient = this.parseRecipient(map.quote_recipient);
      return Object.defineProperty({envelope: Object.freeze({...envelope}), canonical, map, documentCopy, recipient, currency: map.currency, items, totals, allDiscounts, cartDiscounts, itemCount: this.integer(map.item_count, 1), renderedAt}, 'quoteNumber', {value: this.numericReference(envelope.quote_reference), enumerable: true});
    }

    checkFresh(server, fields, nonce, started) {
      const now = Date.now() / 1000;
      if (server.map.generation_nonce !== nonce || server.map.po_assertion !== fields.PO || server.map.note_assertion !== fields.Note || !/^[a-f0-9-]{32,40}$/.test(nonce)) throw new Error('readback_error');
      if (server.renderedAt < started / 1000 - 60 || server.renderedAt > now + 60 || now - server.renderedAt > 300) throw new Error('freshness_error');
    }

    appComparable(application, includeTotal = true) {
      const result = Object.fromEntries(['title', 'type', 'value_type', 'target_type', 'target_selection'].map(key => [key, String(application?.[key] ?? '')]));
      const value = String(application?.value ?? '');
      result.value = value !== '' && Number.isFinite(Number(value)) ? String(Number(value)) : value;
      if (includeTotal) result.total_allocated_amount = this.integer(application?.total_allocated_amount);
      return result;
    }

    ajaxCart(cart) {
      if (!cart || !Array.isArray(cart.items) || !cart.items.length || cart.items.length > 50 || !/^[A-Z]{3}$/.test(cart.currency)) throw new Error('capacity_error');
      const items = cart.items.map(item => {
        const result = Object.fromEntries(['key', 'sku', 'title'].map(key => [key, this.text(String(item[key] ?? ''))]));
        result.product_id = String(item.product_id);
        result.variant_id = String(item.variant_id);
        for (const key of ['quantity', 'original_price', 'final_price', 'original_line_price', 'final_line_price', 'line_level_total_discount']) result[key] = this.integer(item[key], key === 'quantity' ? 1 : 0);
        result.allocations = (item.line_level_discount_allocations || []).map(value => ({amount: this.integer(value.amount), application: this.appComparable(value.discount_application, false)}));
        result.components = (item.item_components || []).map(value => ({variant_id: String(value.variant_id ?? value.id), sku: String(value.sku ?? ''), quantity: this.integer(value.quantity, 1)}));
        return result;
      });
      return {currency: cart.currency, itemCount: this.integer(cart.item_count, 1), totals: Object.fromEntries(['original_total_price', 'items_subtotal_price', 'total_discount', 'total_price'].map(key => [key, this.integer(cart[key])])), items, cartDiscounts: (cart.cart_level_discount_applications || []).map(value => this.appComparable(value)), taxesIncluded: cart.taxes_included === true, requiresShipping: cart.requires_shipping === true};
    }

    comparableServer(server) {
      return {currency: server.currency, itemCount: server.itemCount, totals: server.totals, items: server.items.map(item => ({...item, allocations: item.allocations.map(value => ({amount: value.amount, application: this.appComparable(value.application, false)}))})), cartDiscounts: server.cartDiscounts.map(value => this.appComparable(value)), taxesIncluded: server.map.taxes_included === 'true', requiresShipping: server.map.requires_shipping === 'true'};
    }

    itemMismatchPath(expected, observed) {
      // All path segments are fixed schema names; never emit values, indices or counts.
      const application = {title: null, type: null, value: null, value_type: null, target_type: null, target_selection: null};
      const schema = [{key: null, product_id: null, variant_id: null, sku: null, title: null,
        quantity: null, original_price: null, final_price: null, original_line_price: null,
        final_line_price: null, line_level_total_discount: null,
        allocations: [{amount: null, application}], components: [{variant_id: null, sku: null, quantity: null}]}];
      const type = value => value === null ? 'null' : Array.isArray(value) ? 'array' : typeof value;
      const describe = (path, left, right) => `${path} (${type(left)}/${type(right)})`;
      const visit = (left, right, shape, path) => {
        if (type(left) !== type(right)) return describe(path, left, right);
        if (Array.isArray(shape)) {
          if (!Array.isArray(left) || !Array.isArray(right)) return left === right ? '' : describe(path, left, right);
          if (left.length !== right.length) return describe(path + '.length', left.length, right.length);
          for (let index = 0; index < left.length; index++) {
            const result = visit(left[index], right[index], shape[0], path + '[]');
            if (result) return result;
          }
          return '';
        }
        if (shape && left && right && typeof left === 'object' && typeof right === 'object') {
          for (const key of Object.keys(shape)) {
            const result = visit(left[key], right[key], shape[key], path + '.' + key);
            if (result) return result;
          }
          return '';
        }
        return left === right ? '' : describe(path, left, right);
      };
      return visit(expected, observed, schema, 'items') || 'items (array/array)';
    }

    compare(server, cart) {
      this.itemMismatchDetail = '';
      const observed = this.ajaxCart(cart), expected = this.comparableServer(server);
      const witness = this.bundleWitnesses?.get(cart);
      if (witness) {
        this.checkFresh(witness, {PO: server.map.po_assertion, Note: server.map.note_assertion}, server.map.generation_nonce, server.renderedAt * 1000);
        if (this.stableMap(witness) !== this.stableMap(server)) throw this.staleError('QQ-B01');
        cart.items.forEach((item, index) => {
          if (item.has_components === true && !Object.hasOwn(item, 'item_components')) {
            const components = witness.items[index]?.components;
            if (!components?.length) throw new Error('snapshot_error');
            observed.items[index].components = components.map(component => ({...component}));
          }
        });
      }
      this.showEvidence(server, observed);
      const stable = value => JSON.stringify(value, (key, item) => item && typeof item === 'object' && !Array.isArray(item) ? Object.fromEntries(Object.keys(item).sort().map(name => [name, item[name]])) : item);
      if (stable(observed) !== stable(expected)) {
        // Classify only after the unchanged full comparison has rejected.
        // Only a fixed code is exposed, never values or customer/cart details.
        const groups = [
          ['currency', 'QQ-V01'], ['itemCount', 'QQ-V02'], ['totals', 'QQ-V03'],
          ['items', 'QQ-V04'], ['cartDiscounts', 'QQ-V05'],
          ['taxesIncluded', 'QQ-V06'], ['requiresShipping', 'QQ-V07']
        ];
        const mismatch = groups.find(([field]) => stable(observed[field]) !== stable(expected[field]));
        if (mismatch?.[0] === 'items') this.itemMismatchDetail = this.itemMismatchPath(expected.items, observed.items);
        throw this.failureError('comparison_error', mismatch ? mismatch[1] : 'QQ-V00');
      }
      return observed;
    }

    stableMap(server) {
      return JSON.stringify(Object.entries(server.map).filter(([key]) => !['rendered_at_epoch', 'rendered_at_iso'].includes(key)));
    }

    async run(operation) {
      if (this.busy || !this.allowed()) return false;
      this.busy = true;
      this.abort = new AbortController();
      this.operationTimer = setTimeout(() => this.abort.abort(), 20000);
      this.updateButtons();
      try { await operation(); return true; }
      catch (error) {
        const aborted = error.name === 'AbortError';
        this.invalidate(aborted ? 'stale' : error.message, aborted ? (this.staleDiagnostic || 'QQ-A01') : error.quoteDiagnostic);
        return false;
      }
      finally { clearTimeout(this.operationTimer); this.busy = false; this.updateButtons(); }
    }

    async generate(preserveChallenge=false) {
      if (this.busy || !this.allowed()) return false;
      this.invalidate('building','',preserveChallenge);
      if (!this.form.reportValidity()) return false;
      return this.run(async () => {
        if (this.cartPending()) throw new Error('wait_cart');
        const saveSequence = this.sequence;
        if (!window.EmergentNativeFields || window.EmergentNativeFields.checkoutPending) throw new Error('wait_cart');
        await window.EmergentNativeFields.flush();
        if (this.abort.signal.aborted || saveSequence !== this.sequence) throw this.staleError('QQ-I01');
        if (this.cartPending()) throw new Error('wait_cart');
        const sequence = this.sequence, fields = this.fields(), assertions = this.assertions(), nonce = crypto.randomUUID(), started = Date.now(), createdPerformance = performance.now();
        const update = new URL(this.cartBase.href + '/update.js');
        await (await this.request(update, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {...fields, 'QuickQuote request nonce': nonce}})})).json();
        const readback = await this.readCart();
        this.checkReadback(readback, fields, nonce);
        const server = await this.serverEnvelope();
        this.checkFresh(server, fields, nonce, started);
        this.compare(server, readback);
        const current = await this.readCart();
        this.checkReadback(current, fields, nonce);
        this.compare(server, current);
        if (sequence !== this.sequence) throw this.staleError('QQ-G01');
        if (this.cartPending()) throw this.staleError('QQ-G02');
        if (JSON.stringify(this.fields()) !== JSON.stringify(fields)) throw this.staleError('QQ-G03');
        if (JSON.stringify(this.assertions()) !== JSON.stringify(assertions)) throw this.staleError('QQ-G04');
        const transport = {warning: this.copy.mark, mode: 'QUOTE_REQUEST_SUBJECT_TO_VERIFICATION', issuer_authenticated: false, order_accepted: false, issued: false, netwise_verified: false, snapshot: server.envelope, quote_terms: this.termsRecord(server), ...(server.map.quote_recipient ? {quote_recipient: server.recipient} : {}), customer_assertions_unverified: assertions, return_to_cart: this.returnToCartURL()};
        const contactBody = JSON.stringify(transport);
        if (contactBody.length > 64000) throw new Error('capacity_error');
        this.snapshot = {server, fields, assertions, nonce, createdPerformance, contactBody};
        this.bodyField.value = contactBody;
        this.panel.replaceChildren();
        this.panel.hidden = true;
        this.status.textContent = this.copy.ready;
        this.expiryTimer = setTimeout(() => this.invalidate('expired'), Math.min(300000, Math.max(0, (server.renderedAt + 300) * 1000 - Date.now())));
      });
    }

    async freshForAction() {
      if (!this.isReady()) throw this.staleError(this.readinessDiagnostic());
      const snapshot = this.snapshot, sequence = this.sequence, started = Date.now();
      this.status.textContent = this.copy.checking;
      const cart = await this.readCart();
      this.checkReadback(cart, snapshot.fields, snapshot.nonce);
      this.compare(snapshot.server, cart);
      const current = await this.serverEnvelope();
      this.checkFresh(current, snapshot.fields, snapshot.nonce, started);
      if (this.stableMap(current) !== this.stableMap(snapshot.server)) throw this.staleError('QQ-M01');
      if (sequence !== this.sequence) throw this.staleError('QQ-M02');
      if (!this.isReady()) throw this.staleError(this.readinessDiagnostic());
      return snapshot;
    }









    cleanupPrint() {
      document.documentElement.classList.remove('qq-demo-print-authorized');
      this.authorizeNextPrint = false;
      if (this.originalTitle != null) { document.title = this.originalTitle; this.originalTitle = null; }
    }

    node(tag, text, className) {
      const node = document.createElement(tag);
      if (text != null) node.textContent = text;
      if (className) node.className = className;
      return node;
    }

    money(value, currency) {
      const format=new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,currencyDisplay:'code'});
      return format.formatToParts(value/100).map(part=>part.type==='currency'&&currency==='USD'?'USD $':part.value).join('');
    }

    showEvidence(server, observed) {
      this.lastComparison = {reference: server.envelope.quote_reference, observed};
    }

    validatePrintTotals(server) {
      const original = server.items.reduce((sum, item) => sum + item.original_line_price, 0);
      const lines = server.items.reduce((sum, item) => sum + item.final_line_price, 0);
      if (original !== server.totals.original_total_price) throw this.failureError('comparison_error', 'QQ-T01');
      if (lines !== server.totals.items_subtotal_price) throw this.failureError('comparison_error', 'QQ-T02');
      if (original - server.totals.total_discount !== server.totals.total_price) throw this.failureError('comparison_error', 'QQ-T03');
    }

    parseRecipient(raw) {
      if (raw == null) return Object.freeze({has_address: false, lines: Object.freeze([]), email: ''});
      const value = JSON.parse(this.text(raw, 12000));
      if (!value || Object.keys(value).sort().join(',') !== 'address_html,email,has_address' || typeof value.has_address !== 'boolean') throw new Error('snapshot_error');
      const html = this.text(value.address_html, 10000), email = this.text(value.email, 250);
      const text = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/?p(?:\s[^>]*)?>/gi, '');
      if (/<[^>]*>/.test(text) || (!value.has_address && html)) throw new Error('snapshot_error');
      const decoder = document.createElement('textarea'); decoder.innerHTML = text;
      const lines = decoder.value.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
      if (lines.length > 32 || (value.has_address && !lines.length)) throw new Error('snapshot_error');
      return Object.freeze({has_address: value.has_address, lines: Object.freeze(lines), email});
    }

    recipientLines(server) {
      return server.recipient.has_address ? server.recipient.lines : [this.copy.address_not_provided];
    }

    termsRecord(server) {
      return {version: server.map.terms_version, text: server.map.terms_text, document_copy: server.documentCopy};
    }

    discountDetails(server) {
      const entries = [];
      for (const item of server.items) {
        for (const allocation of item.allocations) {
          const amount = this.integer(allocation.amount);
          if (amount > 0) entries.push({scope: item.sku || item.title, title: allocation.application.title || this.copy.unnamed_discount, amount});
        }
      }
      for (const application of server.cartDiscounts) {
        const amount = this.integer(application.total_allocated_amount);
        if (amount > 0) entries.push({scope: this.copy.cart_discount_scope, title: application.title || this.copy.unnamed_discount, amount});
      }
      if (!entries.length && server.totals.total_discount > 0) entries.push({scope: this.copy.cart_discount_scope, title: this.copy.unnamed_discount, amount: server.totals.total_discount});
      return entries;
    }

    businessNode(server) {
      const copy = server.documentCopy;
      const business = this.node('address', null, 'qq-doc__business');
      business.append(this.node('p', copy.legal_entity, 'qq-doc__name'), this.node('p', copy.dba + ' ' + copy.trade_name, 'qq-doc__name'));
      for (const line of copy.business_address.split('\n')) business.append(this.node('p', line));
      const contactLine=this.node('div',null,'qq-doc__business-line');
      if(copy.business_ein)contactLine.append(this.node('span',copy.business_ein));
      const contacts = this.node('span',null,'qq-doc__business-contacts'), email = this.node('a', copy.business_email), phone = this.node('a', copy.business_phone);
      email.href = 'mailto:' + copy.business_email;
      phone.href = 'tel:+16125427979';
      if(copy.business_email)contacts.append(email);
      if(copy.business_phone){if(copy.business_email)contacts.append(this.node('span',' • '));contacts.append(phone);}
      if(contacts.childNodes.length){if(copy.business_ein)contacts.prepend(this.node('span',' • '));contactLine.append(contacts);}business.append(contactLine);
      return business;
    }

    termsNode(server) {
      const copy = server.documentCopy;
      const terms = this.node('footer', null, 'qq-doc__terms');
      terms.append(this.node('h3', copy.terms_heading));
      if (copy.order_terms) {
        const payment = this.node('p'); payment.style.marginBottom = '0';
        payment.append(this.node('span', copy.payment_terms + ' ' + copy.credit_terms + ' '), this.node('strong', copy.validity_terms, 'qq-doc__validity'));
        terms.append(payment);
      } else terms.append(this.node('p', copy.payment_terms), this.node('p', copy.credit_terms), this.node('p', copy.validity_terms, 'qq-doc__validity'));
      if (copy.order_terms) {
        const heading = this.node('h3', copy.order_terms_heading);
        heading.style.margin = '0';
        terms.append(heading, this.node('p', copy.order_terms), this.node('p', '* ' + copy.pricing_error_terms, 'qq-doc__pricing-caveat'));
      }
      const sale = this.node('p'), label = copy.terms_link_label, parts = copy.sale_terms.split(label), linkedTerms = this.node('a', label);
      linkedTerms.href = copy.terms_url; linkedTerms.target = '_blank'; linkedTerms.rel = 'noopener noreferrer';
      sale.append(this.node('span', parts[0]), linkedTerms, this.node('span', parts.slice(1).join(label))); terms.append(sale);
      if (copy.po_instruction) {
        const po = this.node('p', null, 'qq-doc__po-instruction'), address = 'orders@emergentcpap.com', pieces = copy.po_instruction.split(address);
        if (pieces.length === 2) {
          const mail = this.node('a', address); mail.href = 'mailto:' + address;
          po.append(this.node('span', pieces[0]), mail, this.node('span', pieces[1]));
        } else po.textContent = copy.po_instruction;
        terms.append(po);
      }
      if (copy.quick_quote_note) terms.append(this.node('p', copy.quick_quote_note, 'qq-doc__quick-note'));
      if (!copy.order_terms) terms.append(this.node('p', '* ' + copy.pricing_error_terms, 'qq-doc__pricing-caveat'));
      const custom = this.node('section', null, 'qq-doc__custom'); custom.append(this.node('h3', copy.custom_quote_heading), this.node('p', copy.custom_quote_text));
      const email = this.node('a', copy.business_email); email.href = 'mailto:' + copy.business_email;
      const form = this.node('a', copy.rfq_url); form.href = copy.rfq_url; form.target = '_blank'; form.rel = 'noopener noreferrer';
      const links = this.node('p', null, 'qq-doc__custom-links'); links.append(email, this.node('span', ' • '), form); custom.append(links); terms.append(custom);
      if (copy.form_revision) terms.append(this.node('p', copy.form_revision, 'qq-doc__form-revision'));
      return terms;
    }

    discountNode(server) {
      const entries = this.discountDetails(server);
      if (!entries.length) return null;
      const section = this.node('div', null, 'qq-doc__discounts'), details = this.node('dd'); section.append(this.node('dt', this.copy.discounts_heading), details);
      const list = this.node('ul');
      for (const entry of entries) {
        const row = this.node('li'); row.append(this.node('span', entry.scope + ' — ' + entry.title), this.node('span', this.money(entry.amount, server.currency))); list.append(row);
      }
      details.append(list, this.node('p', this.copy.discounts_included));
      return section;
    }

    layoutPrintPages() {
      this.panel.querySelector('.qq-paper-pages')?.remove();
      this.panel.classList.remove('qq-print-paginated');
      const flow = this.panel.querySelector('.qq-doc__flow');
      if (!flow || !this.panel.getBoundingClientRect().width) return;
      const pages = this.node('div', null, 'qq-paper-pages qq-paper-measuring');
      this.panel.append(pages);
      const limit = 974; // Conservative Letter budget inside 10 mm vertical margins, also safe on A4.
      let page, body;
      // Reserve the attached summary from the start. It always follows real
      // content and its continuous table extension, before the final terms region.
      const footer = flow.querySelector('.qq-doc__page-footer');
      const newPage = (termsOnly=false) => {
        page=this.node('section',null,'qq-paper-page');body=this.node('div',null,'qq-paper-body');
        if(pages.children.length){const header=this.node('header',null,'qq-doc__continuation-header');header.append(this.node('strong','Quick Quote — continued'),flow.querySelector('.qq-doc__date').cloneNode(true));body.append(header);}
        const summary=footer.cloneNode(true);summary.querySelector('.qq-paper-page__number')?.remove();
        const termsRegion=this.node('div',null,'qq-paper-terms-region');
        const documentFooter=flow.querySelector('.qq-doc__document-footer').cloneNode(true);documentFooter.querySelector('.qq-paper-page__number').textContent='Page 1 of 1';
        if(pages.children.length){const original=this.querySelector('[data-qq-brand-logo]')?.content.querySelector('img');if(original){const logo=original.cloneNode(true);logo.className='qq-doc__continuation-logo';logo.hidden=false;logo.alt=this.copy.brand||'Emergent Respiratory';logo.width=100;logo.height=32;logo.sizes='100px';logo.loading='eager';documentFooter.querySelector('.qq-doc__document-brand').append(logo);}}
        const tableSpace=this.node('div',null,'qq-doc__table-space');tableSpace.setAttribute('aria-hidden','true');
        page.append(body,tableSpace,summary,termsRegion,documentFooter);pages.append(page);
        if(termsOnly)body.append(this.node('p','Terms continuation — no additional items on this page.','qq-doc__terms-continuation'));
      };
      const tooTall = () => page.getBoundingClientRect().height > limit + 1;
      const block = original => {
        if (!original) return;
        const clone = original.cloneNode(true); body.append(clone);
        if (tooTall() && body.children.length > 1) { clone.remove(); newPage(); body.append(clone); }
        if (tooTall()) throw new Error('natural-flow');
      };
      try {
        newPage(); block(flow.querySelector('.qq-doc__header'));
        const meta = flow.querySelector('.qq-doc__meta').cloneNode(true);
        const note = meta.querySelector('.qq-doc__requester-note');
        let remainingNote = note?.textContent || '';
        if (note) note.textContent = '';
        body.append(meta);
        if (tooTall()) { meta.remove(); newPage(); body.append(meta); }
        if (tooTall()) throw new Error('natural-flow');
        let noteTarget = note;
        while (remainingNote) {
          noteTarget.textContent = remainingNote;
          if (!tooTall()) break;
          // Fit the actual wrapped text, preserving every character and newline.
          let low = 0, high = remainingNote.length;
          while (low < high) {
            const middle = Math.ceil((low + high) / 2);
            noteTarget.textContent = remainingNote.slice(0, middle);
            if (tooTall()) high = middle - 1; else low = middle;
          }
          if (low && /[\uD800-\uDBFF]/.test(remainingNote[low - 1])) low--;
          if (!low) { noteTarget.textContent = ''; } else {
            const boundary = remainingNote.lastIndexOf('\n', low - 1);
            if (boundary > low / 2) low = boundary + 1;
            noteTarget.textContent = remainingNote.slice(0, low);
            remainingNote = remainingNote.slice(low);
          }
          newPage();
          const continued = this.node('dl', null, 'qq-doc__meta qq-doc__note-continuation');
          const group = this.node('div', null, 'qq-doc__customer-reference');
          noteTarget = this.node('dd', null, 'qq-doc__requester-note');
          group.append(this.node('dt', this.copy.requester_note || 'Quote requester’s note', 'qq-doc__requester-note-label'), noteTarget);
          continued.append(group); body.append(continued);
          noteTarget.textContent = remainingNote.slice(0, 2);
          if (tooTall()) throw new Error('natural-flow');
        }
        const original = flow.querySelector('table');
        let table, rows, scroll;
        const newTable = () => { scroll = this.node('div', null, 'qq-doc__scroll'); table = original.cloneNode(false); table.append(original.querySelector('thead').cloneNode(true)); rows = this.node('tbody'); table.append(rows); scroll.append(table); body.append(scroll); };
        newTable();
        for (const originalRow of original.querySelectorAll('tbody > tr')) {
          const row = originalRow.cloneNode(true); rows.append(row);
          if (tooTall()) {
            row.remove(); if (!rows.children.length) scroll.remove();
            newPage(); newTable(); rows.append(row);
          }
          if (tooTall()) throw new Error('natural-flow');
        }
        const originalTerms=flow.querySelector('.qq-doc__terms');
        const detail=flow.querySelector('.qq-doc__closing > .qq-doc__discounts');
        const fullTerms=this.node('div',null,'qq-doc__full-terms');
        
        if(detail)fullTerms.append(detail.cloneNode(true));
        fullTerms.append(originalTerms.cloneNode(true));
        let region=page.querySelector('.qq-paper-terms-region');region.append(fullTerms);
        if(tooTall())fullTerms.remove();
        if(!fullTerms.isConnected){
          const previousPage=page,previousRows=rows;
          newPage(true);region=page.querySelector('.qq-paper-terms-region');region.append(fullTerms);
          if(!tooTall()){
            // Move only the last real item, when it fits, to avoid a terms-only
            // page. Do not redistribute rows merely to balance blank space.
            if(previousRows.children.length>1){
              const lastRow=previousRows.lastElementChild,label=body.querySelector('.qq-doc__terms-continuation');label?.remove();newTable();rows.append(lastRow);
              if(tooTall()){previousRows.append(lastRow);scroll.remove();if(label)body.append(label);}
            }
          }else{
            // Exceptionally long terms may span sheets. Keep headings with their
            // first paragraph and label terms-only sheets without invented rows.
            fullTerms.remove();
            const groups=[];

            if(detail)groups.push([detail.cloneNode(true)]);
            const children=[...originalTerms.children];
            for(let i=0;i<children.length;i++){
              const group=[children[i].cloneNode(true)];
              if(children[i].tagName==='H3'&&children[i+1])group.push(children[++i].cloneNode(true));
              groups.push(group);
            }
            // Exceptionally long terms occupy trailing continuation sheets; do not place them among item pages.
            region=page.querySelector('.qq-paper-terms-region');
            let terms=originalTerms.cloneNode(false);region.append(terms);
            for(const group of groups){
              terms.append(...group);
              if(tooTall()){
                group.forEach(n=>n.remove());if(!terms.children.length)terms.remove();
                newPage(true);region=page.querySelector('.qq-paper-terms-region');terms=originalTerms.cloneNode(false);region.append(terms);terms.append(...group);
              }
              if(tooTall())throw new Error('natural-flow');
            }
          }
        }
        if(fullTerms.isConnected){
          // Balance contiguous, indivisible item rows by their rendered heights.
          // Keep the approved greedy layout as a fallback, and never add sheets.
          const sheets=[...pages.children],firstItem=sheets.findIndex(sheet=>sheet.querySelector('tbody tr'));
          const candidates=sheets.slice(firstItem),itemRows=candidates.flatMap(sheet=>[...sheet.querySelectorAll('tbody > tr')]);
          if(firstItem>=0&&candidates.length>1&&itemRows.length<=250){
            const saved=sheets.map(sheet=>sheet.cloneNode(true));
            try{
              const heights=itemRows.map(row=>row.getBoundingClientRect().height),prefix=[0];
              heights.forEach(height=>prefix.push(prefix[prefix.length-1]+height));
              const tableTemplate=original.cloneNode(false);tableTemplate.append(original.querySelector('thead').cloneNode(true),this.node('tbody'));
              fullTerms.remove();
              for(const sheet of candidates){
                sheet.querySelector('.qq-doc__terms-continuation')?.remove();
                sheet.querySelector('.qq-doc__scroll')?.remove();
                const holder=this.node('div',null,'qq-doc__scroll');holder.append(tableTemplate.cloneNode(true));sheet.querySelector('.qq-paper-body').append(holder);
              }
              let allocation;
              // Try fewer sheets first; final-page terms are mandatory capacity,
              // optional repeated blocks are considered only after allocation.
              for(let count=1;count<=candidates.length&&!allocation;count++){
                candidates[count-1].querySelector('.qq-paper-terms-region').append(fullTerms);
                const capacities=candidates.slice(0,count).map(sheet=>{
                  // Exclude the intentional blank extension used to position
                  // the attached total; it must never consume row capacity.
                  const prior=sheet.style.minHeight;sheet.style.minHeight='0';
                  const capacity=limit-sheet.getBoundingClientRect().height;
                  sheet.style.minHeight=prior;return capacity;
                });
                fullTerms.remove();
                const target=prefix[itemRows.length]/count;
                const cost=Array.from({length:count+1},()=>Array(itemRows.length+1).fill(Infinity));
                const previous=Array.from({length:count+1},()=>Array(itemRows.length+1).fill(-1));cost[0][0]=0;
                for(let part=1;part<=count;part++)for(let end=part;end<=itemRows.length-(count-part);end++){
                  for(let start=end-1;start>=part-1;start--){
                    const height=prefix[end]-prefix[start];if(height>capacities[part-1])break;
                    const score=cost[part-1][start]+(height-target)**2;
                    if(score<cost[part][end]){cost[part][end]=score;previous[part][end]=start;}
                  }
                }
                if(Number.isFinite(cost[count][itemRows.length])){
                  const cuts=[itemRows.length];for(let part=count;part>0;part--)cuts.unshift(previous[part][cuts[0]]);
                  allocation={count,cuts};
                }
              }
              if(!allocation)throw new Error('retain-approved-pagination');
              const {count,cuts}=allocation;
              candidates.slice(count).forEach(sheet=>sheet.remove());
              for(let index=0;index<count;index++)candidates[index].querySelector('tbody').append(...itemRows.slice(cuts[index],cuts[index+1]));
              candidates[count-1].querySelector('.qq-paper-terms-region').append(fullTerms);
              if([...pages.children].some(sheet=>sheet.getBoundingClientRect().height>limit+1))throw new Error('retain-approved-pagination');
            }catch{
              pages.replaceChildren(...saved);
            }
          }
          // The final page always carries the complete approved terms. Earlier
          // pages may repeat whole semantic blocks, without moving item rows.
          const semanticBlocks=[];let currentBlock;
          for(const child of originalTerms.children){
            if(!currentBlock||child.tagName==='H3'||child.classList.contains('qq-doc__po-instruction')||child.classList.contains('qq-doc__custom')){
              currentBlock=this.node('section',null,'qq-doc__term-block');
              currentBlock.dataset.termBlock=String(semanticBlocks.length);semanticBlocks.push(currentBlock);
            }
            currentBlock.append(child.cloneNode(true));
          }
          const priority=semanticBlocks.map((block,index)=>({block,index,rank:block.querySelector('.qq-doc__custom')?0:block.querySelector('.qq-doc__po-instruction')?1:2})).sort((a,b)=>a.rank-b.rank||a.index-b.index);
          for(const sheet of pages.children){
            const target=sheet.querySelector('.qq-paper-terms-region');
            if(target.children.length)continue;
            const copy=originalTerms.cloneNode(false);target.append(copy);
            for(const {block,index} of priority){
              const candidate=block.cloneNode(true),next=[...copy.children].find(n=>Number(n.dataset.termBlock)>index);
              copy.insertBefore(candidate,next||null);
              if(sheet.getBoundingClientRect().height>limit+1)candidate.remove();
            }
            if(!copy.children.length)copy.remove();
          }
        }
        for(const sheet of pages.children){
          const sheetBody=sheet.querySelector('.qq-paper-body'),termsRegion=sheet.querySelector('.qq-paper-terms-region');
          if(termsRegion.children.length)sheet.classList.add('qq-paper-page--terms');
          if(!sheetBody.querySelector('tbody tr')&&termsRegion.children.length&&!sheetBody.querySelector('.qq-doc__terms-continuation')){
            sheetBody.append(this.node('p','Terms continuation — no additional items on this page.','qq-doc__terms-continuation'));
            if(sheet.getBoundingClientRect().height>limit+1)throw new Error('natural-flow');
          }
        }
        for(const sheet of pages.children){
          const table=sheet.querySelector('table'),space=sheet.querySelector('.qq-doc__table-space');
          if(!table)space.classList.add('qq-doc__table-space--plain');
        }
        const count = pages.children.length;
        [...pages.children].forEach((sheet, index) => {
          sheet.querySelector('.qq-paper-page__number').textContent = `Page ${index + 1} of ${count}`;
        });
        pages.classList.remove('qq-paper-measuring'); this.panel.classList.add('qq-print-paginated');
      } catch {
        // Oversize blocks use normal browser fragmentation; never clip or overlap content.
        pages.remove();
      }
    }

    render(snapshot) {
      if (!this.isPrintPage || this.recordAccepted !== snapshot.contactBody) return;
      const {server, assertions, fields} = snapshot, money = value => this.money(value, server.currency), content = this.node('div', null, 'qq-doc__flow');
      this.panel.classList.remove('qq-print-paginated');
      const header = this.node('header', null, 'qq-doc__header'), identity = this.node('div', null, 'qq-doc__identity'), reference = this.node('div', null, 'qq-doc__reference');
      const heading = this.node('h2', server.documentCopy.snapshot_heading); heading.append(this.node('sup', '*', 'qq-doc__asterisk'));
      identity.append(this.brandNode(), heading);
      reference.append(this.businessNode(server));
      reference.append(this.node('p', 'Reference: '+server.quoteNumber, 'qq-doc__header-reference'));
      reference.append(this.node('p', this.copy.quote_date + ': ' + this.quoteDate(server.renderedAt), 'qq-doc__date'));
      header.append(reference, identity); content.append(header);
      const meta = this.node('dl', null, 'qq-doc__meta');
      const recipient = this.node('div', null, 'qq-doc__recipient'), address = this.node('dd');
      recipient.append(this.node('dt', this.copy.quote_for), address);
      for (const line of this.recipientLines(server)) address.append(this.node('p', line));
      const email = server.recipient.email || assertions.email;
      if (email) {const contact=this.node('a',email,'qq-doc__contact');contact.href='mailto:'+email;recipient.querySelector('dt').append(contact);}
      const customerReference = this.node('div', null, 'qq-doc__customer-reference');
      customerReference.append(this.node('dt', this.copy.customer_reference), this.node('dd', fields.PO || this.copy.not_provided));
      if (fields.Note.trim()) {
        customerReference.append(this.node('dt', this.copy.requester_note || 'Quote requester’s note', 'qq-doc__requester-note-label'), this.node('dd', fields.Note, 'qq-doc__requester-note'));
      }
      meta.append(recipient, customerReference);
      content.append(meta);
      const scroll = this.node('div', null, 'qq-doc__scroll'), table = this.node('table'), thead = this.node('thead'), head = this.node('tr');
      for (const key of ['item', 'sku', 'quantity', 'unit_price', 'line_total']) { const th = this.node('th', this.copy[key]); th.scope = 'col'; head.append(th); }
      thead.append(head); table.append(thead); const body = this.node('tbody');
      for (const item of server.items) {
        const row = this.node('tr'), title = this.node('td'); title.append(this.node('strong', item.title));
        if (item.components.length) {
          const components = this.node('div', null, 'qq-doc__components');
          components.append(this.node('small', this.copy.included_components, 'qq-doc__components-label'));
          for (const component of item.components) components.append(this.node('small', `${component.sku || component.variant_id} × ${component.quantity}`));
          title.append(components);
        }
        row.append(title, this.node('td', item.sku || this.copy.not_provided, 'qq-doc__sku'), this.node('td', String(item.quantity)));
        for (const [original, final] of [['original_price', 'final_price'], ['original_line_price', 'final_line_price']]) {
          const cell = this.node('td'); cell.append(this.node('span', money(item[final])));
          if (item[original] !== item[final]) cell.append(this.node('del', money(item[original])));
          row.append(cell);
        }
        body.append(row);
      }
      table.append(body); scroll.append(table); content.append(scroll);
      const totals = this.node('dl', null, 'qq-doc__totals');
      const entries = server.totals.total_discount > 0 ? [[this.copy.before_savings, money(server.totals.original_total_price)], [this.copy.savings, '−' + money(server.totals.total_discount)]] : [];
      entries.push([this.copy.quoted_total, money(server.totals.total_price)]);
      entries.forEach(([label,value],index) => { const row = this.node('div', null, index === entries.length - 1 ? 'qq-doc__grand-total' : ''); row.append(this.node('dt', label),this.node('dd', value));totals.append(row); if (label === this.copy.savings) { const discounts = this.discountNode(server); if (discounts) totals.append(discounts); } });
      const closing = this.node('div', null, 'qq-doc__closing');
      const totalBlock = this.node('div', null, 'qq-doc__total-block');
      totalBlock.append(totals, this.node('p', server.documentCopy.shipping_tax, 'qq-doc__shipping'));
      // Item/cart discount detail stays in the document body; summary amounts repeat.
      const detail = totals.querySelector('.qq-doc__discounts');
      if (detail) closing.append(detail);
      const terms = this.termsNode(server);
      terms.querySelector('.qq-doc__form-revision')?.remove();
      closing.append(terms); content.append(closing);
      const footer = this.node('footer', null, 'qq-doc__page-footer');
      const identifiers = this.node('div', null, 'qq-doc__footer-identifiers');
      identifiers.append(this.node('p', 'Total shown is for the entire quote, not this page.'));
      identifiers.append(totalBlock.querySelector('.qq-doc__shipping'));
      footer.append(identifiers,totalBlock);
      content.insertBefore(footer,closing);
      const documentFooter=this.node('footer',null,'qq-doc__document-footer'),left=this.node('div',null,'qq-doc__document-identifiers'),center=this.node('div',null,'qq-doc__document-brand'),right=this.node('div',null,'qq-doc__document-pagination');
      left.append(this.node('p',server.documentCopy.form_revision),this.node('p',this.copy.reference+': '+this.displayReference(server)));
      right.append(this.node('p',null,'qq-paper-page__number'),this.node('p',(server.documentCopy.expiration_date||'Expires')+': '+this.quoteDate(server.renderedAt+30*86400),'qq-doc__expiry'));
      documentFooter.append(left,center,right);content.append(documentFooter);
      this.panel.replaceChildren(content);
    }

    removeChallenge() {
      this.turnstileToken=null;this.tokenReceivedAt=0;this.challengeGeneration=(this.challengeGeneration||0)+1;
      if(this.widgetId!==undefined){try{window.turnstile?.remove(this.widgetId);}catch{}this.widgetId=undefined;}
    }
    async showChallenge(requestId) {
      this.removeChallenge();
      const generation=this.challengeGeneration;
      if(!window.turnstile){
        if(!window.ecpapTurnstileLoader)window.ecpapTurnstileLoader=new Promise((resolve,reject)=>{
          const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;script.defer=true;
          const timer=setTimeout(()=>reject(new Error('captcha_error')),15000);
          script.onload=()=>{clearTimeout(timer);resolve();};script.onerror=()=>{clearTimeout(timer);reject(new Error('captcha_error'));};document.head.append(script);
        }).catch(error=>{window.ecpapTurnstileLoader=null;throw error;});
        await window.ecpapTurnstileLoader;
      }
      if(generation!==this.challengeGeneration||this.requestId!==requestId||!this.isConnected||!this.securityPanel.open)return;
      const state=this.querySelector('[data-security-status]');
      this.widgetId=window.turnstile.render(this.querySelector('[data-turnstile]'),{sitekey:this.dataset.sitekey,size:window.innerWidth<360?'compact':'normal',action:this.liveMode?'quickquote_live':'quickquote_test',cData:requestId,'response-field':false,
        callback:token=>{if(generation===this.challengeGeneration&&this.requestId===requestId&&this.securityPanel.open&&this.isConnected){this.turnstileToken=token;this.tokenReceivedAt=Date.now();state.textContent=this.feedbackMode?(this.refreshIntent?'Security check complete. Preparing your refreshed quote.':'Security check complete. Select Refresh quote when ready.'):this.copy.recorder_verified;this.updateButtons();this.finishRefresh();}},
        'expired-callback':()=>{if(generation!==this.challengeGeneration)return;this.turnstileToken=null;state.textContent='Security check expired. Complete it again before recording.';this.updateButtons();},
        'error-callback':()=>{if(generation!==this.challengeGeneration)return;this.turnstileToken=null;state.textContent='Security check needs attention. Cancel and try again; no request was submitted.';this.updateButtons();return true;}});
      this.updateButtons();
    }
    async backend(path,body,live=this.liveMode) {
      if(!this.allowed()||!['/requests','/recover','/verify'].includes(path))throw new Error('unavailable');
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),25000);
      try{const response=await fetch(this.dataset.recorder+(live?'/live':'')+path,{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',redirect:'error',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body),signal:controller.signal});
        const result=await response.json();if(!response.ok){const error=new Error('page_unconfirmed');error.backendCode=result?.error;error.httpStatus=response.status;throw error;}return result;
      }finally{clearTimeout(timer);}
    }
    saveLocalRecord(record) {
      const key=this.recordKey(record.ticket),raw=JSON.stringify(record);sessionStorage.setItem(key,raw);if(sessionStorage.getItem(key)!==raw)throw new Error('storage_error');
      sessionStorage.setItem(this.storageKey+':last',JSON.stringify({ticket:record.ticket}));
    }
    readLocalRecord(ticket) {
      const record=JSON.parse(sessionStorage.getItem(this.recordKey(ticket))||'null');
      if(record?.schema!==(this.liveMode?'ECPAP-RECOVERY-1':'ECPAP-TEST-RECOVERY-1')||record.ticket!==ticket||record.requestId!==ticket||!/^[a-f0-9]{64}$/.test(record.recoverySecret||'')||!record.snapshot)throw new Error('page_missing');
      return record;
    }
    openRecordTab(record,preparedChild) {
      const child=preparedChild||window.open('about:blank','qq_record_'+record.ticket.replaceAll('-',''));
      if(!child||child.closed)throw new Error('print_tab_unavailable');
      try{child.document.title=this.copy.recorder_waiting;child.document.body.textContent=this.copy.recorder_waiting_tab;child.sessionStorage.setItem(this.recordKey(record.ticket),JSON.stringify(record));child.opener=null;}
      catch(error){child.close();throw error;}return child;
    }
    async recordQuote(preparedChild) {
      if(this.recording||this.busy||this.lastRecordTicket||!this.turnstileToken||!this.isReady())return false;
      this.recording=true;this.updateButtons();const sequence=this.sequence;let record,child,sent=false;
      try{
        record={schema:this.liveMode?'ECPAP-RECOVERY-1':'ECPAP-TEST-RECOVERY-1',ticket:this.requestId,requestId:this.requestId,recoverySecret:[...crypto.getRandomValues(new Uint8Array(32))].map(n=>n.toString(16).padStart(2,'0')).join(''),snapshot:JSON.parse(JSON.stringify({envelope:this.snapshot.server.envelope,email:this.snapshot.assertions.email,fields:this.snapshot.fields}))};
        // Synchronous user-gesture popup and storage checks happen before any request.
        this.saveLocalRecord(record);child=this.openRecordTab(record,preparedChild);
        await this.freshForAction();
        if(!this.turnstileToken||child.closed||sequence!==this.sequence||!this.isConnected||Date.now()-this.tokenReceivedAt>=290000)throw new Error('stale');
        const token=this.turnstileToken;this.turnstileToken=null;this.lastRecordTicket=record.ticket;this.previousVerified=false;sent=true;
        clearTimeout(this.expiryTimer);this.status.textContent=this.copy.recorder_waiting;
        const receipt=await this.backend('/requests',{requestId:record.requestId,recoverySecret:record.recoverySecret,turnstileToken:token,themeId:this.dataset.themeId,snapshot:record.snapshot});
        await this.verifyReceipt(receipt,record);
        this.previousRecordTicket=null;this.previousVerified=true;this.querySelector('[data-new-test]').hidden=false;
        this.status.textContent=this.notificationMessage(receipt);
        this.securityPanel.close();this.securityPanel.hidden=true;this.removeChallenge();
        if(child&&!child.closed)child.location.replace(this.printURL(record.ticket).href);
        return true;
      }catch(error){
        if(sent&&error.httpStatus===403&&error.backendCode==='captcha_not_verified'){
          this.lastRecordTicket=null;sessionStorage.removeItem(this.storageKey+':last');sessionStorage.removeItem(this.recordKey(record.ticket));this.restorePreviousRecord();child?.close();this.invalidate('captcha_error');this.status.textContent='The server did not verify the security check. No quote was recorded. Start again to retry.';
        }else if(sent){
          this.previousRecordTicket=null;
          this.securityPanel.close();this.securityPanel.hidden=true;this.removeChallenge();
          this.status.textContent=this.copy.page_unconfirmed;
          if(child&&!child.closed)child.location.replace(this.printURL(record.ticket).href);
        }else{
          if(record){if(JSON.parse(sessionStorage.getItem(this.storageKey+':last')||'null')?.ticket===record.ticket)sessionStorage.removeItem(this.storageKey+':last');sessionStorage.removeItem(this.recordKey(record.ticket));}this.restorePreviousRecord();child?.close();this.status.textContent=error.message==='print_tab_unavailable'?this.copy.recorder_popup:this.failureText(error.message);
        }
        return false;
      }finally{this.recording=false;this.updateButtons();if(sent||!this.securityPanel.open)this.showFeedback(this.status.textContent);}
    }
    async verifyReceipt(receipt,record,live=this.liveMode) {
      if(receipt?.schema!==(live?'ECPAP-RECORDED-QUOTE-1':'ECPAP-RECORDED-QUOTE-TEST-1')||receipt.environment!==(live?'ecpap-qq-live-159941787853-v1':'ecpap-qq-test-159941787853-v1')||receipt.keyId!=='qq-test-20261025-v1'||receipt.pricesApproved!==false||receipt.orderAccepted!==false||!['pending_configuration','queued','provider_accepted','failed'].includes(receipt.notificationStatus)||!/^\d{16}$/.test(receipt.reference)||!/^[a-f0-9]{64}$/.test(receipt.integrityCode)||!Number.isFinite(Date.parse(receipt.recordedAt)))throw new Error('snapshot_error');
      const stable=v=>v===null||typeof v!=='object'?JSON.stringify(v):Array.isArray(v)?'['+v.map(stable).join(',')+']':'{'+Object.keys(v).sort().map(k=>JSON.stringify(k)+':'+stable(v[k])).join(',')+'}';
      if(stable(receipt.snapshot)!==stable(record.snapshot))throw new Error('snapshot_error');
      const verification=await this.backend('/verify',{receipt},live);
      if(verification.valid!==true||verification.environment!==receipt.environment||verification.pricesApproved!==false||verification.orderAccepted!==false)throw new Error('snapshot_error');
      return receipt;
    }
    notificationMessage(receipt) {
      const messages={pending_configuration:this.copy.recorder_pending_mail,queued:this.copy.recorder_queued_mail,provider_accepted:this.copy.recorder_accepted_mail,failed:this.copy.recorder_failed_mail};
      return this.copy.recorder_saved+' '+(messages[receipt?.notificationStatus]||'Staff notification outcome is not confirmed.');
    }
  });
}
